import React from 'react';

import { revoke } from 'Auth/sources';

import { oktaAuth } from './oktaAuth';

const retryRenewToken = async (counter = 0, limit = 5, retryDelay = 500) => {
  try {
    await oktaAuth.tokenManager.renew('accessToken');
    // await oktaAuth.tokenManager.renewToken(accessTokenObject);
  } catch (e) {
    await new Promise((resolve) => setTimeout(() => resolve(), retryDelay));
    if (counter < limit) {
      return retryRenewToken(counter + 1, limit, retryDelay);
    }
  }
};

export const useOkta = () => {
  const [authState, setAuthState] = React.useState(null);

  React.useEffect(() => {
    if (!oktaAuth) {
      return;
    }

    // Add okta-react userAgent
    oktaAuth.userAgent = `GG ${oktaAuth.userAgent}`;
    // Update Security provider with latest authState
    const handler = (authState) => {
      // eslint-disable-next-line no-console
      // console.debug('[OKTA] setAuthState', authState);
      setAuthState(authState);
    };
    oktaAuth.authStateManager.subscribe(handler);

    /* eslint-disable */
    oktaAuth.tokenManager.on('error', function (err) {
      console.log('[OKTA] Error err.name', err?.name);
      console.log('[OKTA] Error err.message', err?.message);
      console.log('[OKTA] Error err', err);
    });
    oktaAuth.tokenManager.on('renewed', function (key, newToken, oldToken) {
      // console.log('[OKTA] Token renewed', key, 'has been renewed');
    });
    oktaAuth.tokenManager.on('expired', function (key, expiredToken) {
      // console.log('[OKTA] Token expired', key, ' has expired');
    });
    oktaAuth.tokenManager.on('removed', function (key, removedToken) {
      // console.log('[OKTA] Token removed', key, ' has removed');
    });
    oktaAuth.tokenManager.on('added', function (key, addedToken) {
      // console.log('[OKTA] Token added', key, ' has added');
    });
    /* eslint-enable */

    // Trigger an initial change event to make sure authState is latest
    if (!oktaAuth.isLoginRedirect()) {
      // Calculates initial auth state and fires change event for listeners
      // Also starts the token auto-renew service
      oktaAuth.start();
    }

    return () => {
      oktaAuth.authStateManager.unsubscribe(handler);
      oktaAuth.stop();
    };
  }, [oktaAuth]);

  const handleGetAccessToken = async (
    counter = 0,
    limit = 5,
    retryDelay = 1000
  ) => {
    /* eslint-disable */
    const accessTokenObject = await oktaAuth.tokenManager.get('accessToken');
    if (accessTokenObject) {
      if (oktaAuth.tokenManager.hasExpired(accessTokenObject)) {
        console.debug('[OKTA] Renew Tokens in API Interceptor');
        console.debug(
          '[OKTA] Renew Tokens Debug before',
          oktaAuth.getAccessToken()
        );
        await retryRenewToken();

        console.debug(
          '[OKTA] Renew Tokens Debug after',
          oktaAuth.getAccessToken()
        );
      }
      return oktaAuth.getAccessToken();
    } else {
      console.debug(
        '[OKTA] Catch get Token',
        accessTokenObject,
        oktaAuth.getAccessToken()
      );
      await new Promise((resolve) => setTimeout(() => resolve(), retryDelay));
      if (counter < limit) {
        return handleGetAccessToken(counter + 1, limit, retryDelay);
      }
    }

    /* eslint-enable */
  };

  return {
    _hasError: false,
    _name: 'octa',
    loaded: !!authState,
    isLoginRedirect: () => oktaAuth.isLoginRedirect(),
    callback: async () => {
      console.log('auth Callback!');

      try {
        await oktaAuth.handleRedirect();
        // window.location.pathname = process.env.REACT_APP_PUBLIC_URL;
      } catch (err) {
        console.error('Error during callback handling:', err);
      }
    },
    login: () => {
      console.debug('[OKTA] Login');
      const currentUrl = window.location.pathname + window.location.search;

      // Store current page URL before redirecting
      oktaAuth.setOriginalUri(currentUrl);

      oktaAuth.signInWithRedirect();
    },
    logout: async () => {
      // eslint-disable-next-line no-console
      console.debug('[OKTA] Logout');
      try {
        await revoke();
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
      } finally {
        oktaAuth.tokenManager.clear();
        oktaAuth.authStateManager.updateAuthState();
      }
    },
    active: false,
    getAccessToken: handleGetAccessToken,
    isAuthenticated: authState?.isAuthenticated || false,
    onUnauthorized: () => {
      // eslint-disable-next-line no-console
      console.debug('[OKTA] onUnauthorized');
      oktaAuth.tokenManager.clear();
      oktaAuth.authStateManager.updateAuthState();
    },
  };
};
